// lt-edit
class ProductRequest extends HTMLElement {
  static get observedAttributes() {
    return ['data-display'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-display') {
      if (newValue === '') {
        document.documentElement.dataset.unscrollable = '';
      }
      else {
        delete document.documentElement.dataset.unscrollable;
      }
    }
  }

  async connectedCallback() {
    if (document.readyState === 'loading') {
      await new Promise(resolve => document.addEventListener('DOMContentLoaded', resolve, { once: true }));
    }

    const parent = this.parentElement;
    if (parent && parent.tagName == 'SECTION') {
      parent.replaceWith(this);
      return;
    }

    this.refs = {
      close: this.querySelector('[data-close-ref]'),
      productInput: this.querySelector('[data-product-input-ref]'),
      requestTypeSelect: this.querySelector('[data-request-type-field]')
    };

    const urlParse = URL.parse(window.location.href);
    if (urlParse?.searchParams.get('contact_posted')) {
      this.dataset.display = '';
    }

    this.#listeners();
  }

  disconnectedCallback() {
    // Clean up listeners or resources here
  }

  #listeners() {
    document.addEventListener('productrequest:toggle', () => {
      this.dataset.display = '';
    });

    document.addEventListener('productrequest:type', ({ detail }) => {
      const value = detail.value;
      if (value && this.refs.requestTypeSelect) {
        const option = this.refs.requestTypeSelect.querySelector(`[data-request-type-value="${value}"]`);
        if (option) {
          this.refs.requestTypeSelect.value = option.value;
        }
      }
    });

    this.refs?.close?.addEventListener('pointerup', () => {
      delete this.dataset.display;
    });

    document.addEventListener('variant:update', (e) => {
      if (!this.refs.productInput) return;
      const variantTitle = e.detail.resource.title;
      const productTitle = this.refs.productInput.dataset.productTitle;
      const value = `${productTitle} - ${variantTitle}`;
      this.refs.productInput.value = value;
    });

    this.addEventListener('pointerup', (e) => {
      if (e.target.tagName === 'PRODUCT-REQUEST') {
        delete this.dataset.display;
      }
    });
  }
}

customElements.define('product-request', ProductRequest);
